// permissions.js
export default {
    install(Vue) {
        Vue.prototype.$can = function(permission) {
            // 从 localStorage 中获取权限列表
            const permissions = JSON.parse(localStorage.getItem('logistics-permissions')) || [];
            // 检查用户是否具有特定权限
            return permissions.includes(permission);
        };
        Vue.prototype.$employeesName = function(empId) {
            if (empId != ''){
                // 从 localStorage 中获取权限列表
                const permissions = JSON.parse(localStorage.getItem('employees-name')) || [];
                // 检查用户是否具有特定权限
                const item = permissions.find(obj => obj.key === empId);
                return item ? item.value : null; // 如果找到则返回value，否则返回null
            } else {
                return null;
            }

        };
        Vue.prototype.$userIdToUserInfo = function(userId) { // 根据userId 返回用户的基本信息
            if (userId != ''){
                // 从 localStorage 中获取权限列表
                const userIdToUserInfoArr = JSON.parse(localStorage.getItem('user-id-to-user-info')) || [];
                // 检查用户是否具有特定权限
                const item = userIdToUserInfoArr.find(obj =>obj.empId === userId);
                const params = {name:''};
                return item ? item : params; // 如果找到则返回value，否则返回null
            } else {
                return null;
            }

        };
    }
};
